import { makeStyles, Theme } from "@material-ui/core/styles";

export function useDetailsInfoStyles() {
    const useStyles = makeStyles((theme: Theme) => ({
        head: {
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            padding: theme.spacing(2),
        },
        content: {
            padding: theme.spacing(2),
        },
        container: {
            display: "flex",
            flexDirection: "column",
            width: "100%",
            flex: 1,
            gap: theme.spacing(2),
        },
        header: {
            display: "flex",
            gap: theme.spacing(2),
            alignItems: "center",
        },
        headerButtonGroup: {
            gap: theme.spacing(2),
            display: "flex",
            justifyContent: "end",
            flex: 1,
        },
        title: {
            fontSize: theme.typography.pxToRem(24),
            fontWeight: 400,
            color: theme.palette.text.primary,
            textTransform: "capitalize",
        },
        subtitle: {
            fontSize: theme.typography.pxToRem(16),
            fontWeight: 400,
            marginBottom: theme.spacing(1),
            color: "#333",
        },
        infosContainer: {
            display: "flex",
            gap: theme.spacing(3),
            color: theme.palette.text.secondary,
        },
        infoContainer: {
            display: "flex",
            alignItems: "flex-start",
            gap: theme.spacing(1),
        },
        icons: {
            fontSize: theme.typography.pxToRem(20),
        },
        infoContainerText: {
            fontSize: theme.typography.pxToRem(14),
            fontWeight: 400,
        },
        priorityInfoContainer: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: theme.spacing(1),
        },
        priorityInfoTitle: {
            color: "#706E7A",
            fontWeight: 400,
            fontSize: theme.typography.pxToRem(14),
        },
        priorityInfoText: {
            color: theme.palette.text.primary,
            fontSize: theme.typography.pxToRem(14),
            fontWeight: 400,
        },
        badge: {
            padding: "6px 10px",
            letterSpacing: 1,
            fontSize: theme.typography.pxToRem(13),
            fontWeight: 400,
            borderRadius: 20,
            textAlign: "center",
            color: "#FFF",
        },
        active: {
            backgroundColor: "#2E7D32",
            "&:hover": {
                backgroundColor: "#2E7D32",
            },
        },
        inactive: {
            backgroundColor: "#C62828",
            "&:hover": {
                backgroundColor: "#C62828",
            },
        },
        editButton: {
            width: "100%",
            maxWidth: 109,
            backgroundColor: theme.palette.primary.main,
            fontSize: theme.typography.pxToRem(14),
            color: "#fff",
            fontWeight: 500,
            "&:hover": {
                backgroundColor: theme.palette.primary.main,
            },
        },
    }));

    const classes = useStyles();

    return {
        classes,
    };
}
